<template>

  <div class="main">

    <div id="pc">

      <div>
        <div class="text">
          <div>
            <p>桌面应用</p>
            <!-- <p><a :href="webUrl" target="_blank" rel="noopener noreferrer">网页版</a></p> -->
            <p>PC版</p>
            <p>Mac版(开发中)</p>
          </div>
          <div>
            <p>支持与服务</p>
            <p><a href="https://api.haiouchat.com/api/sys/toHtml?dictType=agreement&code=agreementMember"
                target="_blank" rel="noopener noreferrer">用户协议</a></p>
            <p><a href="https://api.haiouchat.com/api/sys/toHtml?dictType=agreement&code=agreementPrivacy"
                target="_blank" rel="noopener noreferrer">隐私协议</a></p>
            <p>
              <router-link to="/aboutUs">关于我们</router-link>
            </p>
          </div>
          <div>
            <p>联系方式</p>
            <p>电话：{{phone}}</p>
            <p>邮箱：{{email}}</p>
            <p>地址：{{address}}</p>
          </div>

        </div>

        <div class="qr">
          <div>
            <img src="@/img/pc/qr.png" alt="">
            <p>iOS下载</p>
          </div>
          <div>
            <img src="@/img/pc/qr.png" alt="">
            <p>安卓下载</p>
          </div>


        </div>



      </div>
      <div>
        <p>违法和不良信息举报电话: 4008833821 &nbsp &nbsp 网上有害信息举报专区 涉未成年人等不良信息举报邮箱： haiouim@qq.com </p>

      </div>
      <div>
        <span>成都争渡科技有限公司 <a
            href="https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%E5%B7%9DB2-20211396&type=xuke"
            target="_blank" rel="noopener noreferrer">经营许可证编号 {{businessLicenseNumber}}</a> </span>
        <span><img src="@/img/pc/gongan@2x.png" alt=""><a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002004874" target="_blank"
            rel="noopener noreferrer">川公网安备 {{publicRecordNumber}}号</a></span>
        <span><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            rel="noopener noreferrer">{{recordNumber}}</a></span>
        <span>Copyright © {{new Date().getFullYear()}}.海鸥 All rights reserved.</span>
          <span class="py" ><a  href="http://scpiyao.org.cn" target="_blank"> <img src="@/img/py.jpg" alt="" >  </a> </span>
      </div>



    </div>

    <div id="mobile">

      <div>
        <div>
          <span>手机应用</span>
          <span>iOS</span>
          <span>Android</span>
        </div>

        <div>
          <span>支持与服务</span>
          <span><a href="https://api.haiouchat.com/api/sys/toHtml?dictType=agreement&code=agreementMember"
              rel="noopener noreferrer">用户协议</a></span>
          <span><a href="https://api.haiouchat.com/api/sys/toHtml?dictType=agreement&code=agreementPrivacy"
              rel="noopener noreferrer">隐私协议</a></span>
          <span>
            <router-link to="/aboutUs">关于我们</router-link>
          </span>
        </div>

        <div>
          <span>客服热线</span>
          <span>{{phone}}</span>
        </div>

        <div>
          <span>企业邮箱</span>
          <span>{{email}}</span>
        </div>

        <div>
          <span>企业地址</span>
          <span>{{address}}</span>
        </div>



      </div>
      <div>
        <p>成都争渡科技有限公司 <a
            href="https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%E5%B7%9DB2-20211396&type=xuke"
            target="_blank" rel="noopener noreferrer">经营许可证编号 {{businessLicenseNumber}}</a></p>
        <p>违法和不良信息举报电话: 4008833821</p>
        <p>网上有害信息举报专区</p>
        <p>涉未成年人等不良信息举报邮箱： haiouim@qq.com </p>
        <p><img src="@/img/pc/gongan@2x.png" alt=""><a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002004874" target="_blank"
            rel="noopener noreferrer">川公网安备 {{publicRecordNumber}}号</a> <a
            href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            rel="noopener noreferrer">{{recordNumber}}</a></p>
        <p>Copyright © {{new Date().getFullYear()}} .海鸥 All rights reserved.</p>
      </div>
    </div>




  </div>

</template>

<script>
  import api from "@/api/api";
  import request from '@/api/request';
  import {
    Notify
  } from 'vant';
  import {
    Dialog
  } from 'vant';
  export default {
    components: {

    },
    data() {
      return {
        phone: '4008833821',
        email: 'haiouim@qq.com',
        address: '成都市天府三街新希望国际B座2309',
        recordNumber: '蜀ICP备20019844号-2',
        publicRecordNumber: '51019002004874',
        businessLicenseNumber: '川B2-20211396',
        webUrl: "https://web.haiouchat.com/"

      }
    },
    created() {


    },
    computed: {

    },
    mounted() {


    },

    destroyed() {

    },
    methods: {

      downApp() {
        var userAgent = navigator.userAgent;
        //console.log(userAgent)
        //alert(userAgent)
        var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; //android终端
        var isIOS = !!userAgent.match(/macintosh|mac os x/i);
        //alert(isIOS)
        //0 安卓 1 ios
        var type = 0;
        if (isIOS) {
          //window.location.href = 'https://apps.apple.com/cn/app/%E6%B5%B7%E9%B8%A5m/id6449927022'
          //window.location.href = 'itms-services://?action=download-manifest&amp;url=https://zd.oss.haiouchat.com/manifest.plist'
          window.location.href =
            'https://apps.apple.com/cn/app/%E6%B5%B7%E9%B8%A5-%E5%AE%89%E5%85%A8%E5%8A%A0%E5%AF%86%E8%81%8A%E5%A4%A9%E4%BA%A4%E5%8F%8B%E8%BD%AF%E4%BB%B6/id1584062834'


        } else {
          window.location.href = 'https://www.haiouchat.com/app/haiou.apk'
        }


      }


    }
  }

</script>

//pc
<style scoped>
  /* 当屏幕宽度大于或等于768像素时，改为浮动布局 */
  @media (min-width: 768px) {

    #mobile {
      display: none;
    }

    .main {
      width: 100%;
      height: 300px;
      background: #F8F8F8;

    }

    #pc>div:first-child {
      margin-left: 360px;
      margin-right: 360px;
      padding-top: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .text {

      display: flex;
      flex-direction: row;
      align-items: center;






      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }

    .text>div {
      width: max-content;
      margin-right: 130px;
    }

    .text>div>p:first-child {


      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;

    }

    .qr {

      display: flex;
      flex-direction: row-reverse;
      align-items: center;



    }

    .qr>div {
      margin-left: 60px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #333333;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;

    }

    .qr>>>img {
      width: 108px;
      height: 108px;

    }

    #pc>div:nth-child(2) {
      margin-top: 18px;


      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;

    }


    #pc>div:last-child {
      /* margin-top: 16px; */
      margin-bottom: 32px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;

    }

    #pc>div:last-child>span {
      margin-left: 40px;

    }

    #pc>div:last-child>span>img {
      width: 16px;
      height: 16px;
      position: relative;
      top: 4px;
      right: 2px;

    }
.py>>>img{

  width: 120px;
  height: 30px;

}

  }

</style>

//移动端
<style scoped>
  /* 当屏幕宽度小于或等于768像素时，应用以下样式 */
  @media (max-width: 768px) {
    #pc {
      display: none;
    }

    #mobile {
      width: 100%;
      height: 356px;
      background: #F8F8F8;
    }

    #mobile>div:first-child>div {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      padding-left: 24px;
      padding-top: 20px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 14px;
      text-align: left;
      font-style: normal;
      text-transform: none;


    }

    #mobile>div:first-child>div>span:first-child {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #333333;
      line-height: 14px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 40px;
    }

    #mobile>div:first-child>div>span:nth-child(2) {
      margin-right: 36px;
    }

    #mobile>div:first-child>div:nth-child(2)>span:first-child {
      margin-right: 28px;
    }

    #mobile>div:first-child>div:nth-child(2)>span:nth-child(2) {
      margin-right: 40px;
      text-decoration: underline
    }

    #mobile>div:first-child>div:nth-child(2)>span:nth-child(3) {
      margin-right: 40px;
      text-decoration: underline
    }

    #mobile>div:first-child>div:nth-child(2)>span:last-child {

      text-decoration: underline
    }

    #mobile>div:last-child {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    #mobile>div:last-child>p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 0px;
      margin-bottom: 8px;
    }

    #mobile>div:last-child>p:first-child {

      margin-top: 36px;

    }

    #mobile>div:last-child>p:nth-child(5)>img {

      width: 12px;
      height: 12px;
      position: relative;
      top: 2px
    }


    #mobile>div:last-child>p:last-child {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 8px;
      margin-bottom: 0px;
    }


  }

</style>



// WEBPACK FOOTER //
// src/components/bottom/index.vue